/* KOLDE - bulle WhatsApp flottante. 27/08/2026.
 * Charge sur toutes les pages par sections/kolde-nav-loader.liquid.
 * Styles : assets/kolde-whatsapp.css
 *
 * Comportement : clic sur la bulle -> petit panneau KOLDE ; le bouton du
 * panneau ouvre wa.me -> WhatsApp s'ouvre chez le visiteur (application sur
 * mobile, WhatsApp Web/Desktop sur ordinateur) et les messages arrivent
 * dans le WhatsApp du numero ci-dessous.
 *
 * La bulle occupe le coin en haut de page, puis remonte au-dessus de la
 * fleche « retour en haut » du theme des que celle-ci apparait (voir plus bas,
 * bloc « la bulle remonte quand la fleche apparait »).
 *
 * Mouvement : le flottement continu est en CSS (.kwa__bob). Ici on ajoute la
 * reaction au scroll : chaque coup de molette envoie une impulsion dans un
 * ressort amorti, pose en transform inline sur .kwa__float. Les deux couches
 * sont distinctes exprès : un transform inline sur l'element anime en CSS
 * ecraserait l'animation.
 *
 * Pour changer le numero ou le message : les 2 constantes juste en dessous.
 */
(function () {
  'use strict';

  var PHONE = '971553405579';                                   // format international, sans + ni espaces
  var PREFILL = "Hi KOLDE!\nI'd like some information about your home recovery solutions, so I can choose the right rental plan.";

  if (window.__koldeWa) return;
  window.__koldeWa = true;

  /* glyphe WhatsApp officiel */
  var WA_PATH = 'M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.347-.347.52-.52.174-.174.232-.297.347-.495.116-.198.058-.372-.03-.52-.086-.148-.66-1.585-.905-2.164-.24-.586-.482-.507-.66-.514-.174-.007-.372-.007-.57-.007-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.71.306 1.263.489 1.695.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.29.173-1.414-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z';

  function waIcon(cls) {
    return '<svg class="' + cls + '" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false"><path d="' + WA_PATH + '"/></svg>';
  }

  var HREF = 'https://wa.me/' + PHONE + '?text=' + encodeURIComponent(PREFILL);

  function reduced() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function build() {
    /* Le markup est desormais pose par le serveur (snippets/kolde-whatsapp-markup.liquid),
       pour que la bulle soit peinte des le premier rendu : sur mobile, Lighthouse
       retenait l'etiquette « Chat with us » comme element LCP, et ce script differe
       ne la creait qu'a ~7,7 s. On ne reconstruit donc le DOM que s'il est absent
       (page servie sans le snippet), puis on branche les comportements dans les
       deux cas. ⚠️ Toute modification du markup ci-dessous doit etre reportee a
       l'identique dans le snippet, et inversement. */
    var wrap = document.getElementById('kolde-wa');

    if (!wrap) {
      wrap = document.createElement('div');
      wrap.id = 'kolde-wa';
      wrap.setAttribute('data-open', 'false');

      wrap.innerHTML =
        '<div class="kwa__panel" role="dialog" aria-modal="false" aria-label="Chat with KOLDE on WhatsApp">' +
          '<div class="kwa__head">' +
            '<span class="kwa__avatar">' + waIcon('') + '</span>' +
            '<div>' +
              '<p class="kwa__name">KOLDE Support</p>' +
              '<p class="kwa__status"><i></i>Online</p>' +
            '</div>' +
          '</div>' +
          '<div class="kwa__body">' +
            '<div class="kwa__msg">' +
              '<p><strong>Hello 👋</strong></p>' +
              '<p>A question about renting a cryocompression or electrostimulation device, delivery, home setup, or your recovery protocol?<br>Our team is here to help 🙂</p>' +
              '<span class="kwa__meta">KOLDE team</span>' +
            '</div>' +
          '</div>' +
          '<div class="kwa__foot">' +
            '<a class="kwa__cta" href="' + HREF + '" target="_blank" rel="noopener noreferrer">' + waIcon('') + '<span>Start chat on WhatsApp</span></a>' +
          '</div>' +
        '</div>' +
        '<div class="kwa__float"><div class="kwa__bob">' +
          '<button type="button" class="kwa__btn" aria-label="Chat with us on WhatsApp" aria-expanded="false">' +
            waIcon('kwa__ico-wa') +
            '<svg class="kwa__ico-close" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
          '</button>' +
        '</div></div>' +
        '<button type="button" class="kwa__tip" tabindex="-1" aria-hidden="true">' +
          '<span class="kwa__tip-a">Need help?</span>' +
          '<span class="kwa__tip-b">Chat with us</span>' +
        '</button>';

      document.body.appendChild(wrap);
    }

    var btn = wrap.querySelector('.kwa__btn');
    var panel = wrap.querySelector('.kwa__panel');
    var cta = wrap.querySelector('.kwa__cta');
    var floater = wrap.querySelector('.kwa__float');

    /* renseigne par le bloc de suivi de la fleche, plus bas */
    var refreshLift = null;

    function setOpen(open) {
      wrap.setAttribute('data-open', open ? 'true' : 'false');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      panel.setAttribute('aria-hidden', open ? 'false' : 'true');
      if (open) {
        setTimeout(function () { cta.focus({ preventScroll: true }); }, 280);
      } else if (refreshLift) {
        // la montee est gelee pendant que le panneau est ouvert : on rattrape
        refreshLift();
      }
    }

    setOpen(false);

    btn.addEventListener('click', function () {
      setOpen(wrap.getAttribute('data-open') !== 'true');
    });

    // l'etiquette est visible en permanence : elle doit ouvrir le panneau elle
    // aussi, sinon on affiche « Chat with us » sur une zone morte
    var tip = wrap.querySelector('.kwa__tip');
    if (tip) {
      tip.addEventListener('click', function () {
        setOpen(true);
      });
    }

    // clic en dehors -> on referme
    document.addEventListener('click', function (e) {
      if (wrap.getAttribute('data-open') === 'true' && !wrap.contains(e.target)) setOpen(false);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && wrap.getAttribute('data-open') === 'true') {
        setOpen(false);
        btn.focus({ preventScroll: true });
      }
    });

    cta.addEventListener('click', function () {
      setOpen(false);
    });

    /* ---------- la bulle remonte quand la fleche apparait ---------- */
    /* La fleche retour-en-haut du theme (.progress-wrap) est masquee en haut de
       page et devient visible au scroll (classe .active-progress dans
       ap-theme.css). On la surveille et on pose data-lifted sur le wrapper :
       le CSS fait glisser la bulle de 76px (72px en mobile) au-dessus d'elle.
       Surveillance par MutationObserver sur class ET style (selon les versions
       du theme, la visibilite passe par l'une ou l'autre), + le scroll en
       filet de securite. setTimeout plutot que rAF : rAF est gele dans un
       onglet en arriere-plan, on veut que l'etat soit juste au retour. */
    var arrow = document.querySelector('.progress-wrap');
    if (arrow) {
      var lifted = null;
      var queued = false;

      /* SEUL signal : la classe .active-progress que le theme pose et retire.
         Ne PAS y ajouter de test sur le style calcule. Deux pieges vecus :
         - a l'apparition, l'opacite calculee vaut encore ~0 quand l'observer
           se declenche (transition pas encore avancee) -> montee ratee ;
         - a la disparition, c'est l'inverse et c'est pire : la classe est
           retiree mais l'opacite vaut encore ~1 et `visibility` reste
           `visible` pendant toute la transition (visibility s'anime de facon
           discrete) -> « fleche visible » repondait vrai, la bulle restait en
           haut, et comme plus aucune mutation ni aucun scroll ne survenait
           ensuite, RIEN ne venait corriger. C'est le bug remonte par Cedric :
           bulle bloquee en haut apres un retour en haut de page.
         La classe, elle, bascule instantanement. Si un jour le theme change de
         mecanisme, l'echec est du bon cote : la bulle reste dans le coin. */
      function arrowShown() {
        return arrow.classList.contains('active-progress');
      }

      var downTimer = null;

      function applyLift(v) {
        lifted = v;
        wrap.setAttribute('data-lifted', v ? 'true' : 'false');
      }

      function syncLift() {
        queued = false;
        // panneau ouvert : on ne bouge pas. Deplacer la bulle ferait glisser
        // tout le panneau de 76px d'un coup en pleine lecture. On rattrape a
        // la fermeture (voir setOpen).
        if (wrap.getAttribute('data-open') === 'true') return;
        var now = arrowShown();
        if (now === lifted) return;
        clearTimeout(downTimer);
        if (now) {
          applyLift(true);        // montee : tout de suite
        } else {
          // descente : on laisse la fleche finir son fondu, sinon la bulle
          // arrive dans le coin pendant qu'elle s'y efface encore
          downTimer = setTimeout(function () {
            if (!arrowShown() && wrap.getAttribute('data-open') !== 'true') applyLift(false);
          }, 220);
        }
      }

      function queueLift() {
        if (queued) return;
        queued = true;
        setTimeout(syncLift, 0);
      }

      refreshLift = queueLift;
      syncLift();
      new MutationObserver(queueLift).observe(arrow, { attributes: true, attributeFilter: ['class', 'style'] });
      window.addEventListener('scroll', queueLift, { passive: true });
      window.addEventListener('resize', queueLift, { passive: true });
    }

    /* ---------- reaction au scroll : ressort amorti ---------- */
    if (reduced()) return;

    var pos = 0;        // decalage vertical courant, en px
    var vel = 0;        // vitesse du ressort
    var raf = null;
    var lastY = window.scrollY || document.documentElement.scrollTop || 0;

    /* Valeurs accordees en simulant la boucle hors navigateur (27/08) :
       un cran de molette = ~3px de deplacement, 8px au maximum en scroll
       brutal, retour au repos en 0,5 a 0,8 s. Un premier accord plus mou
       (GAIN .20 / MAXP 22) donnait 13px sur un simple cran et saturait a
       22px, soit un contact avec la fleche retour-en-haut sur mobile.
       Marge verifiee, flottement CSS de 6px inclus : 12px desktop, 8px mobile. */
    var STIFF = 0.18;   // rappel vers 0
    var DAMP = 0.80;    // amortissement
    var GAIN = 0.055;   // part de la vitesse de scroll transmise
    var MAXI = 2;       // impulsion max par evenement
    var MAXP = 8;       // amplitude max, pour ne jamais toucher la fleche

    function tick() {
      vel += (0 - pos) * STIFF;
      vel *= DAMP;
      pos += vel;
      if (pos > MAXP) { pos = MAXP; vel = 0; }
      if (pos < -MAXP) { pos = -MAXP; vel = 0; }

      if (Math.abs(pos) < 0.06 && Math.abs(vel) < 0.06) {
        pos = 0; vel = 0;
        floater.style.transform = '';
        raf = null;
        return;
      }
      floater.style.transform =
        'translate3d(0,' + pos.toFixed(2) + 'px,0) rotate(' + (pos * 0.16).toFixed(2) + 'deg)';
      raf = requestAnimationFrame(tick);
    }

    window.addEventListener('scroll', function () {
      var y = window.scrollY || document.documentElement.scrollTop || 0;
      var d = y - lastY;
      lastY = y;
      if (!d) return;
      // la bulle traine derriere le mouvement, comme un ballon au bout d'un fil
      var imp = d * GAIN;
      if (imp > MAXI) imp = MAXI;
      if (imp < -MAXI) imp = -MAXI;
      vel += imp;
      if (!raf) raf = requestAnimationFrame(tick);
    }, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', build);
  } else {
    build();
  }
})();
